import Isotope from "isotope-layout";
import imagesLoaded from "imagesloaded";
import { FFTabNav } from "./modules/tabNav.js";

const DESKTOP_FILTER_MQ = "(min-width: 64.0625em)";

class FFCollection {

	getParameterByName(name: string, url?: string) {
		if (!url) url = window.location.href;
		name = name.replace(/[[\]]/g, "\\$&");
		const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

  DOM: { 
    grid: HTMLElement | null
    tabNav: FFTabNav | null
    filterControl: HTMLElement | null
    filterTrigger: HTMLButtonElement | null
    filters: NodeListOf<HTMLElement>
  }
  iso!: InstanceType<typeof Isotope>

	constructor(){
		this.DOM = {
			grid: document.querySelector('.js-slimProductGrid'),
			tabNav: document.querySelector(".ff-tabNav"),
			filterControl: document.querySelector('.ff-collectionFilterControl'),
			filterTrigger: document.querySelector('.js-collectionFilterTrigger'),
			filters: document.querySelectorAll('.ff-collectionFilter button'),
		}
		if( !this.DOM.grid ) return;
		this.events();
		imagesLoaded( this.DOM.grid, this.grid.bind(this) );
	}

	events(){
		for( let i=0;i<this.DOM.filters.length;i++){
			this.DOM.filters[i].addEventListener( 'click', this.filter.bind(this) );
		}
		this.DOM.filterTrigger?.addEventListener('click', this.toggleFilterMenu.bind(this));
		document.addEventListener('click', this.handleDocumentClick.bind(this));
		document.addEventListener('keydown', this.handleKeydown.bind(this));
		window.addEventListener('optimizedResize', this.handleViewportResize.bind(this));
	}

	openFilterMenu(){
		this.DOM.filterControl?.classList.add('is-open');
		this.DOM.filterTrigger?.setAttribute('aria-expanded', 'true');
		const activeFilter = [...this.DOM.filters].find(filter => filter.classList.contains('active'));
		requestAnimationFrame(() => activeFilter?.focus());
	}

	closeFilterMenu(restoreFocus = false){
		this.DOM.filterControl?.classList.remove('is-open');
		this.DOM.filterTrigger?.setAttribute('aria-expanded', 'false');
		if( restoreFocus && !window.matchMedia(DESKTOP_FILTER_MQ).matches ){
			this.DOM.filterTrigger?.focus();
		}
	}

	toggleFilterMenu(){
		if( this.DOM.filterControl?.classList.contains('is-open') ){
			this.closeFilterMenu();
		}else{
			this.openFilterMenu();
		}
	}

	handleDocumentClick(e: MouseEvent){
		if( e.target instanceof Node && !this.DOM.filterControl?.contains(e.target) ){
			this.closeFilterMenu();
		}
	}

	handleKeydown(e: KeyboardEvent){
		if( e.key === 'Escape' && this.DOM.filterControl?.classList.contains('is-open') ){
			e.preventDefault();
			this.closeFilterMenu(true);
		}
	}

	handleViewportResize(){
		if( window.matchMedia(DESKTOP_FILTER_MQ).matches ){
			this.closeFilterMenu();
		}
		requestAnimationFrame(() => {
			this.DOM.tabNav?.setIndicatorTo(this.DOM.tabNav.activeIndex);
		});
	}

	setActiveFilter(target: HTMLElement){
		for( let i=0;i<this.DOM.filters.length;i++){
			const isActive = this.DOM.filters[i] === target;
			this.DOM.filters[i].classList.toggle('active', isActive);
			this.DOM.filters[i].setAttribute('aria-pressed', String(isActive));
		}

		const index = [...this.DOM.filters].indexOf(target);
		if( index < 0 ) return;

		if( this.DOM.tabNav ){
			this.DOM.tabNav.activeIndex = index;
			this.DOM.tabNav.setIndicatorTo(index);
		}
	}

	checkQuery(){
		const filter = this.getParameterByName('filter');
		if( !filter ) return;
		const tag = 'tag-' + filter;
		const filterButton = document.querySelector('button[data-filter="' + tag + '"]');
		if( filterButton ){
			this.iso.arrange({ filter: '.' + tag });
			this.setActiveFilter(filterButton as HTMLElement);
		}
	}

	filter(e: MouseEvent){
		const target = e.currentTarget as HTMLElement;
    if( !target || !this.iso ) return
		let filter = target.getAttribute('data-filter');
		if( filter === '*' && target.classList.contains('active') ){
			this.closeFilterMenu(true);
			return;
		}

		filter = ( filter != '*' ) ? '.' + filter : filter;

		//unfilter
		if( target.classList.contains('active') ){
			this.setActiveFilter(this.DOM.filters[0]);
			this.iso.arrange({ filter: '*' });
		//filter
		}else{
			this.setActiveFilter(target);
			this.iso.arrange({ filter: filter });
		}
		this.closeFilterMenu(true);
	}

	grid(){
		this.iso = new Isotope( this.DOM.grid!, {
			itemSelector: '.slimProductGridItem',
			layoutMode: 'fitRows'
		});
		this.checkQuery();
	}
};

new FFCollection();